import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './new-york.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-new-york',
  templateUrl: './new-york.component.html',
  styleUrls: ['./new-york.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
})
export class NewYorkComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('new-york', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('new-york', null);
    }
  }
  optionsSelection = {
    Total_Additional_PIP_Limits: '',
    Monthly_Work_Loss: '',
    Other_Expenses_Per_Day: '',
  };

  override eventHook(value: any): void {
    if (value === 'Additional_PIP_DropDown') {
      this.optionsSelection.Total_Additional_PIP_Limits = '';
      this.optionsSelection.Monthly_Work_Loss = '';
      this.optionsSelection.Other_Expenses_Per_Day = '';
      // Reset drop down values
      this.reactiveForm
        .get('Additional_PIP_DropDown')
        ?.valueChanges.subscribe((value) => {
          if (value.id === 5) {
            if (this.baseRulesService?.pdfDataDump) {
              this.baseRulesService.pdfDataDump[
                'new-york'
              ].additional_pip_Option_1 = false;
              this.baseRulesService.pdfDataDump[
                'new-york'
              ].additional_pip_Option_2 = false;
              this.baseRulesService.pdfDataDump[
                'new-york'
              ].additional_pip_Option_3 = false;
              this.baseRulesService.pdfDataDump[
                'new-york'
              ].additional_pip_Option_4 = false;
            }
          }
        });
    }
  }

  override dynamicRuleQueryBuilder(): string {
    return 'Case1';
    //return "Case2";
  }

  override setupHookForDropDownData(): void {
    setTimeout(() => {
      const pipOptionsDropdown = this.reactiveForm.get(
        'Additional_PIP_DropDown',
      );
      if (pipOptionsDropdown.value) {
        this.updateOptionsFromDropdown(pipOptionsDropdown.value);
      }
    }, 0);
  }

  private updateOptionsFromDropdown(selectedValue: any): void {
    if (!this.controls || !this.controls[2] || !this.controls[2].data) {
      return;
    }

    // Get the option name (handle both string "Option 1" and object {name: "Option 1"} formats)
    const optionName =
      typeof selectedValue === 'string' ? selectedValue : selectedValue?.name;

    if (!optionName) return;

    // Find the matching option in controls[2].data
    const selectedOption: any = this.controls[2].data.find(
      (option: any) => option.name === optionName,
    );

    if (selectedOption) {
      // Update the local variable with values from the selected option
      this.optionsSelection = {
        Total_Additional_PIP_Limits:
          selectedOption.Total_Additional_PIP_Limits || '',
        Monthly_Work_Loss: selectedOption.Monthly_Work_Loss || '',
        Other_Expenses_Per_Day: selectedOption.Other_Expenses_Per_Day || '',
      };
    }
  }
}
